import { useNavigate } from 'react-router-dom';
import { MessageSquare, Calendar, User, Zap } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { PRIORIDADE_MAP } from '../../lib/constants';
import { formatPeriodo, acaoAcontecendoAgora } from '../../lib/dates';

export function DemandaCard({ demanda, compact = false }) {
  const nav = useNavigate();
  const p = PRIORIDADE_MAP[demanda.prioridade];
  const urgente = demanda.prioridade === 'urgente' || demanda.prioridade === 'alta';
  const acontecendo = acaoAcontecendoAgora(demanda.data_acao, demanda.data_acao_fim);
  const dataLabel = demanda.data_acao
    ? formatPeriodo(demanda.data_acao, demanda.data_acao_fim, { short: true })
    : null;

  return (
    <div
      className="demand-card"
      onClick={() => nav(`/demandas/${demanda.codigo}`)}
      style={urgente ? { borderLeft: `3px solid ${p?.dotColor}` } : undefined}
    >
      <div className="demand-card-title">
        <span className="muted" style={{ fontWeight: 400, fontSize: 12, marginRight: 6 }}>#{demanda.id}</span>
        {demanda.titulo}
      </div>
      <div className="demand-card-tags">
        <Badge color="info">{demanda.secretaria_nome}</Badge>
        {p && urgente && <Badge color={p.color}>{p.label}</Badge>}
        {acontecendo && <Badge color="success"><Zap size={10} /> Acontecendo agora</Badge>}
        {demanda.aprovacao === 'aprovado' && <Badge color="success">Aprovado</Badge>}
        {demanda.aprovacao === 'reprovado' && <Badge color="danger">Reprovado</Badge>}
      </div>
      <div className="demand-card-meta">
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Avatar nome={demanda.solicitante_nome} src={demanda.solicitante_foto} size="sm" />
          <span className="muted">{demanda.solicitante_nome?.split(' ')[0]}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {demanda.responsavel_nome && !compact && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }} title={`Responsável: ${demanda.responsavel_nome}`}>
              <User size={12} /> {demanda.responsavel_nome?.split(' ')[0]}
            </span>
          )}
          {demanda.nao_lidas > 0 && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: 'var(--c-primary)', fontWeight: 600 }}>
              <MessageSquare size={13} /> {demanda.nao_lidas}
            </span>
          )}
          {dataLabel && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
              <Calendar size={13} /> {dataLabel}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
